moment = require('../../../node_modules/moment/moment')
clamp = require('../../../core/frontend/vendor_modules/clamp.min')
SharedUser = require('../../shared/frontend/helpers/user')

module.exports =

  getParameterByName: (name, url) ->
    url = window.location.href unless url
    regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)")
    results = regex.exec(url)
    return null unless results
    return '' unless results[2]
    return decodeURIComponent(results[2].replace(/\+/g, " "))

  localizeUTCDates: (format) ->
    UTCSpan = $('span.utc-format')
    _.each(UTCSpan, (span) ->
      $span = $(span)
      utcDates = $span.text()?.trim()
      if utcDates?.length > 0
        date = moment(utcDates)
        if date.isValid()
          if format
            $span.text(date.format(format))
          else
            $span.text(date.format('ll'))
    )

  clampDealOptionTitles: () ->
    optionTitles = $('.deal-option-title')
    _.each(optionTitles, (optionTitle, index) ->
      $clamp(optionTitles.get(index), {clamp: 2})
    )

  isRecaptchaElementPresent: (formType) ->
    if formType is "email"
      $("#touch_email_recaptcha").length > 0
    else if formType is "callback"
      $("#touch_callback_recaptcha").length > 0

  readCaptchaInput: (formType) ->
    if @isRecaptchaElementPresent(formType) && recaptchaWidget?
      grecaptcha.getResponse(recaptchaWidget)
    else
      ""

  isRecaptchaValid: (formType) ->
    if @isRecaptchaElementPresent(formType) && recaptchaWidget?
      return grecaptcha.getResponse(recaptchaWidget).length > 0 
    else
      ""

  # To Show/Hide T Pane
  handleShowOrHidePane: (action, dataSelector) ->
    if action is 'show'
      $(dataSelector).css("display","block")
    else if action is 'hide'
      $(dataSelector).css("display","none")


  eventCreateError: (err) ->
    $('.ajaxshim').remove()

  eventCreateSuccess: (response) ->
    $('.ajaxshim').remove()

  makeEventsInbentaCall: (clickCode) ->
    if not clickCode
      return
    $('body').append("<div class='ajaxshim'></div>")

    callOptions = @collectEventCallData(clickCode,"#{FAQBASEURL}/event", @eventCreateError, @eventCreateSuccess)
    window.eventCall = $.ajax(callOptions)


  collectEventCallData: (clickCode, url, errorCb, successCb) ->
    inbentaSessionToken = sessionStorage.getItem 'inbentaSessionTokenTouch'
    if not inbentaSessionToken
      @createSession()
      return
    callOptions =
      data:
          platform: "mobile"
          sessionToken: inbentaSessionToken,
          type: "click"
          data: {
            code: clickCode
          }
        headers: {}
        dataType: 'json'
        url: url
        type: "POST"
        error: errorCb
        success: successCb
    SharedUser.setGrpnUsrHeader(callOptions)
    callOptions

  backNavigationHandler: ->
    $('.back-link-text').off().on('click', (ev) ->
      return window.history.back()
    )

  bindContinueAsGuestUrl: ->
    $('#continue_guest_button').on('click', (ev)->
    window.sessionStorage.setItem('customer-support-guestCheckout', true)
    )

  # -------- Binding of individual FAQ article/content to enable expanding/deexpanding------#
  bindInbentaContentToggle: () ->
    $articleListElement = $('.article-title-with-icon')

    $articleListElement.on('click', (e) =>
      currentArticle = $(e.currentTarget).closest('.article')
      icon = currentArticle.find('.icon-arrow-nav-right');
      content = currentArticle.find('.content');
      if (icon.css('transform') == 'none')
        @makeEventsInbentaCall(e.currentTarget.id)
        icon.css('transform', 'rotate(90deg)')
        content.removeClass('hide')
      else
        icon.css('transform', 'none')
        content.addClass('hide')
    )
